export function normalizeTextInput(value: string): string {
  if (!value) {
    return value;
  }

  return value.toUpperCase();
}
